/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
// 行政区划代码 → 城市名称 映射字典（4位，用于mapList接口传参和返回值映射）
export const areaIdMap = {
  42: '湖北省',
  4201: '武汉市',
  4202: '黄石市',
  4203: '十堰市',
  4205: '宜昌市',
  4206: '襄阳市',
  4207: '鄂州市',
  4208: '荆门市',
  4209: '孝感市',
  4210: '荆州市',
  4211: '黄冈市',
  4212: '咸宁市',
  4213: '随州市',
  4228: '恩施土家族苗族自治州',
  4290: '仙桃市',
  4291: '潜江市',
  4292: '天门市',
  4293: '神农架林区',
  // 以下为6位code，用于URL参数code的映射
  420100: '武汉市',
  420200: '黄石市',
  420300: '十堰市',
  420500: '宜昌市',
  420600: '襄阳市',
  420700: '鄂州市',
  420800: '荆门市',
  420900: '孝感市',
  421000: '荆州市',
  421100: '黄冈市',
  421200: '咸宁市',
  421300: '随州市',
  422800: '恩施土家族苗族自治州',
  429004: '仙桃市',
  429005: '潜江市',
  429006: '天门市',
  429021: '神农架林区',
}

// 城市名称 → 4位行政区划代码（仅用于mapList接口传参）
export const areaNameMap = {
  '湖北省': '42',
  '武汉市': '4201',
  '黄石市': '4202',
  '十堰市': '4203',
  '宜昌市': '4205',
  '襄阳市': '4206',
  '鄂州市': '4207',
  '荆门市': '4208',
  '孝感市': '4209',
  '荆州市': '4210',
  '黄冈市': '4211',
  '咸宁市': '4212',
  '随州市': '4213',
  '恩施土家族苗族自治州': '4228',
  '仙桃市': '4290',
  '潜江市': '4291',
  '天门市': '4292',
  '神农架林区': '4293',
}

// 将接口返回的 { id, value } 转为 ECharts 需要的 { name, value }
// geoJson 可选，传入时从 GeoJSON 的 features 中提取 adcode→name 映射（用于区级）
export function mapDataToEcharts(data, geoJson) {
  if (!data || !Array.isArray(data)) return []
  let idMap = areaIdMap
  if (geoJson && geoJson.features) {
    idMap = {}
    geoJson.features.forEach(f => {
      if (f.properties && f.properties.adcode && f.properties.name) {
        idMap[f.properties.adcode] = f.properties.name
      }
    })
    Object.assign(idMap, areaIdMap)
  }
  return data.map(item => ({
    name: idMap[item.id] || item.id,
    value: item.value,
  }))
}

export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}
